import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgGift = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M7.9375 2H8.02344C9.26953 2 10.4258 2.66055 11.0586 3.73633L12 5.33828L12.9414 3.73633C13.5742 2.66055 14.7305 2 15.9766 2H16.0625C17.9609 2 19.5 3.53906 19.5 5.4375C19.5 6 19.3633 6.49609 19.125 7H20.75C21.4414 7 22 7.55859 22 8.25V10.75C22 11.4414 21.4414 12 20.75 12H3.25C2.55977 12 2 11.4414 2 10.75V8.25C2 7.55859 2.55977 7 3.25 7H4.875C4.63516 6.49609 4.5 6 4.5 5.4375C4.5 3.53906 6.03906 2 7.9375 2ZM9.44141 4.68672C9.14453 4.18398 8.60547 3.875 8.02344 3.875H7.9375C7.07422 3.875 6.375 4.57461 6.375 5.4375C6.375 6.30078 7.07422 7 7.9375 7H10.8008L9.44141 4.68672ZM16.0625 3.875H15.9766C15.3945 3.875 14.8555 4.18398 14.5586 4.68672L13.1992 7H16.0625C16.9258 7 17.625 6.30078 17.625 5.4375C17.625 4.57461 16.9258 3.875 16.0625 3.875ZM3.25 13.25H10.75V22H5.125C4.08945 22 3.25 21.1602 3.25 20.125V13.25ZM13.25 22V13.25H20.75V20.125C20.75 21.1602 19.9102 22 18.875 22H13.25Z", fill: props.fill }));
});
export default SvgGift;
